import { onInViewport } from "../../../utils/onInViewport";

export const initSchemeMap = () => {
	const components = document.querySelectorAll( 'section.cds2-scheme-map' );
	
	if ( components.length )
	{
		components.forEach(( component ) => {
			
			const breakpoint = 636;
			
			const initComponent = () => {
				const tabsList = component.querySelector( 'ul.tabs' );
				const tabs = tabsList.children;
				const maps = component.querySelectorAll( 'picture.map' );
				const legends = component.querySelectorAll( 'picture.legend' );
				let i = 1;
				let timer;

				const callback = ( tab, index ) => {
					component.querySelectorAll( 'ul.tabs > li' ).forEach( ( item ) => item.classList.remove( 'current' )); 
					tab.classList.add( 'current' );

					component.querySelectorAll( 'picture.map' ).forEach( ( item ) => item.classList.remove( 'current' )); 
					maps[index].classList.add( 'current' );

					component.querySelectorAll( 'picture.legend' ).forEach( ( item ) => item.classList.remove( 'current' )); 

					if ( legends[index] )
					{
						legends[index].classList.add( 'current' );
					}
				}
				
				const animate = () => {
					if ( window.innerWidth > breakpoint )
					{
						timer = setTimeout( () => {
							callback( tabs[i], i );
							i++;
							if ( i < tabs.length ) {
								animate();
							}
						}, 4000 );
					}
				}
				
				tabs.forEach( ( tab, index ) => {
					tab.addEventListener( 'click', () => {
						callback( tab, index );
						tab.closest( 'section.cds2-scheme-map' ).classList.remove( 'animate-component' );
						clearTimeout( timer );
					});
				});
				
				animate();
			}
			
			const onWindowScroll = onInViewport( component, () =>  {
				window.removeEventListener( 'scroll', onWindowScroll );
				initComponent();
			});
			
			onWindowScroll();
			window.addEventListener( 'scroll', onWindowScroll );
		});
	}
}
